import { combineReducers } from 'redux-immutable';

import allProjects from 'reducers/ui/allProjects';
import credits from 'reducers/ui/credits';
import instances from 'reducers/ui/instances';
import instancesStatuses from 'reducers/ui/instancesStatuses';
import paymentMethods from 'reducers/ui/paymentMethods';
import projectDetails from 'reducers/ui/projectDetails';
import sessions from 'reducers/ui/sessions';
import skus from 'reducers/ui/skus';
import users from 'reducers/ui/users';

export default combineReducers({
  allProjects,
  credits,
  instances,
  instancesStatuses,
  paymentMethods,
  projectDetails,
  sessions,
  skus,
  users
});
